import { workPool } from '@wochitnpm/helpers';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';
/**
 * Adapt external assets (like social asset) received via search, to be able to use in
 * lightbox/timeline
 *
 * should replace AssetModel::createBackendAsset();
 */

/** @namespace workPool.job.createExternalAsset */
export default workPool.define(
  'createExternalAsset',
  {
    getContext() {
      return {
        assetId: this.options.asset.id,
      };
    },

    run() {
      const asset = this.options.asset;

      this.beforeRun(asset);

      const postData =
        app.namespace.Controller.AssetController.serializeAsset(asset);
      const isDynamicProvider = app.assetType.isDynamicProvider(asset);

      // Ugly hack alert!
      // External asset creation only works on videos, and not on fragments.
      // The lightbox can only show fragments, and not videos.
      // This code works when adding fragments to the lightbox.
      // so we're converting the fragment to a video. When asset creation ends, we'll convert it back to fragment.
      if (app.assetType.isFRAGMENT(asset) && isDynamicProvider) {
        postData.type = app.assetType.VIDEO;
        postData.metadata.assetType = 'VIDEO';
        delete postData.startTime;
        delete postData.endTime;
      }

      app.api.asset.convert(postData).then((response) => {
        if (response.status && response.status === 'DONE') {
          app.api.asset.fetch(asset.metadata.assetUUID).then((res) => {
            this.onDone(res);
          }, this.onFail.bind(this));
        } else {
          app.api.realTime
            .listenOnAsset(asset.metadata.assetUUID, { isDynamicProvider })
            .then(() => {
              app.api.asset.fetch(asset.metadata.assetUUID).then((res) => {
                this.onDone(res);
              }, this.onFail.bind(this));
            }, this.onFail.bind(this));
        }
      }, this.onFail.bind(this));
    },

    beforeRun(asset) {
      app.Vue.$$set(asset, {
        _previewOp: 'create',
      });
      app.Vue.$$set(asset.metadata, {
        uploadStatus: app.uploadStatus.UPLOAD,
      });
    },

    onDone(res) {
      const asset = this.options.asset;
      res = this.parseConversionResult(res);

      if (
        app.assetType.isFRAGMENT(asset) &&
        app.assetType.isDynamicProvider(asset)
      ) {
        // Converting back from video to fragment (see comment above)
        app.Vue.$$set(
          asset,
          Object.assign(res, {
            id: app.generateAssetId(asset),
            type: app.assetType.FRAGMENT,
            thumbnail: null,
          })
        );
        asset.metadata.assetType = 'VIDEO_SEGMENT';
      } else {
        app.Vue.$$set(
          asset,
          Object.assign(res, {
            _previewOp: 'done',
          })
        );
        asset.metadata.uploadStatus = app.uploadStatus.DONE;
      }
      if (isAssetCandidateForTranscribe(asset)) {
        app.rootStore.dispatch('FETCH_TRANSCRIPTION', {
          asset,
          transcribeSubType: app.transcribeSubType.VIDEO,
          how: workPool.job.transcriptions.HOW.READ_OR_CREATE,
          alertOnError: true,
        });
      }
      this.$emit({ asset });
      this.finish();
    },

    parseConversionResult(res) {
      if (res.metadata.uploadStatus !== app.uploadStatus.DONE) {
        // debugger;// OMG: is it still happening?
      }

      if (app.assetType.isSOCIALFRAGMENT(res)) {
        // fixing invalid data retrieved from backend
        res = _.omit(res, ['duration', 'endTime', 'startTime']);
      }

      if (app.assetType.isGIF(res)) {
        const duration = res.metadata && res.metadata.duration;
        res.endTime = duration;
        res.duration = duration;
      }

      app.namespace.Controller.AssetController.parse(res, {
        generateId: !app.assetType.isSOCIALFRAGMENT(res),
      });

      return _.compactObject(res);
    },

    onFail(error) {
      const asset = this.options.asset;
      app.Vue.set(asset.metadata, 'uploadStatus', app.uploadStatus.FAILED);

      if (error && error.error) {
        this.$emit({ error, asset });
      } else {
        this.$emit({ error: true, asset });
      }

      app.Vue.$$set(asset, {
        _previewOp: 'fail',
      });

      this.abort();
    },
  },
  {
    isRelevant(asset) {
      const notUploaded = asset.metadata.uploadStatus !== app.uploadStatus.DONE;
      const isExternalType =
        app.assetType.isSOCIAL(asset) ||
        app.assetType.isSOCIALFRAGMENT(asset) ||
        app.assetType.isGIF(asset) ||
        app.assetType.isDynamicProvider(asset);

      return notUploaded && isExternalType;
    },

    isRunning(asset) {
      return workPool.has({
        type: this.type,
        context: (jc) => jc.assetId === asset.id,
      });
    },

    execute({ asset }) {
      const isRelevant = this.isRelevant(asset);
      const isRunning = this.isRunning(asset);
      const isNeeded = isRelevant && !isRunning;
      if (isNeeded) {
        const newJob = new this({ asset });
        workPool.add(newJob);
      }
      return isNeeded;
    },

    updateSelectedAsset(asset, selectedAssets) {
      const selectedOne = _.find(selectedAssets, { id: asset.id });
      if (selectedOne && asset !== selectedOne) {
        app.Vue.$$set(selectedOne, asset);
      }
    },
  }
);
